import { Text, TextProps } from "styles/utility-components";

import EllipsisTooltip from "./EllipsisTooltip";
import { TooltipComponentProps } from "./Tooltip";

type EllipsisTextProps = Omit<TextProps, "ellipsis"> & {
  tooltipProps?: Omit<TooltipComponentProps, "children" | "content">;
  children: string;
};

function EllipsisText({
  children,
  tooltipProps,
  ...textProps
}: EllipsisTextProps): React.ReactNode {
  return (
    <EllipsisTooltip fullText={children} tooltipProps={tooltipProps}>
      {(ref) => (
        <Text ref={ref} ellipsis {...textProps}>
          {children}
        </Text>
      )}
    </EllipsisTooltip>
  );
}

export default EllipsisText;
